import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';
import { Spin, Table } from 'antd';
import { isNil, toDateTimeString, parseDate, formatCurrency } from 'vdlib';
import Portlet from 'components/layout/Portlet';
import BidTypeCellRenderer from 'components/tables/datagrid-columns/BidTypeCellRenderer';
import { getAmountDiffCellRenderer } from 'components/tables/datagrid-columns/AmountDiffCellRenderer';

const AuctionHistoryGrid = ({
  auctionId,
  clearData,
  data,
  fetchData,
  fetching,
}) => {
  const columnDefs = React.useMemo(
    () => [
      {
        title: I.t('SN'),
        dataIndex: 'ID',
        width: 25,
        align: 'center',
        render: (text, record, index) => index + 1,
      },
      {
        title: I.t('AMOUNT'),
        dataIndex: 'PartPrice',
        align: 'center',
        render: (text, record) => formatCurrency(record.PartPrice),
      },
      {
        title: I.t('PART_TYPE'),
        render: (text, record) => BidTypeCellRenderer(record),
      },
      {
        title: I.t('DATE'),
        dataIndex: 'Date',
        width: 200,
        calign: 'center',
        render: (_, { Date }) => toDateTimeString(parseDate(Date)),
      },
      {
        title: I.t('DIFFERENCE_FROM_INITIAL_PRICE'),
        field: 'Amount',
        align: 'center',
        render: (_, record) => {
          const AmountDiffCellRenderer = getAmountDiffCellRenderer();
          return <AmountDiffCellRenderer data={record} />;
        },
      },
    ],
    []
  );

  React.useEffect(() => {
    if (!isNil(auctionId)) fetchData(auctionId);
  }, [auctionId]); //eslint-disable-line

  React.useEffect(() => {
    return () => {
      clearData();
    };
  }, []); //eslint-disable-line

  return (
    <Portlet>
      <Spin spinning={fetching} size="large" tip="Loading...">
        <Table columns={columnDefs} dataSource={data} />
      </Spin>
    </Portlet>
  );
};

AuctionHistoryGrid.propTypes = {
  auctionId: PropTypes.any,
};

export default AuctionHistoryGrid;
